import NiceModal from '@ebay/nice-modal-react'

import { BulkReviewModal, Params } from './Modal'

export const showBulkReviewModal = (params: Params) =>
  NiceModal.show(BulkReviewModal, params)
